var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1461 18.1141C16.6511 18.1141 17.8761 19.3304 17.8761 20.8254V24.6704C17.8761 24.9916 18.1336 25.2491 18.4636 25.2566H20.8461C22.7236 25.2566 24.2498 23.7491 24.2498 21.8966V10.9916C24.2411 10.3541 23.9373 9.75412 23.4161 9.35537L15.1748 2.78287C14.0686 1.90662 12.5211 1.90662 11.4111 2.78537L3.22607 9.35287C2.68482 9.76412 2.38107 10.3641 2.37482 11.0129V21.8966C2.37482 23.7491 3.90107 25.2566 5.77857 25.2566H8.18357C8.52232 25.2566 8.79732 24.9879 8.79732 24.6579C8.79732 24.5854 8.80607 24.5129 8.82107 24.4441V20.8254C8.82107 19.3391 10.0386 18.1241 11.5323 18.1141H15.1461ZM20.8461 27.1316H18.4411C17.0636 27.0991 16.0011 26.0178 16.0011 24.6703V20.8253C16.0011 20.3641 15.6173 19.9891 15.1461 19.9891H11.5386C11.0773 19.9916 10.6961 20.3678 10.6961 20.8253V24.6578C10.6961 24.7516 10.6836 24.8416 10.6573 24.9266C10.5223 26.1641 9.46482 27.1316 8.18357 27.1316H5.77857C2.86732 27.1316 0.499817 24.7828 0.499817 21.8966V11.0041C0.512317 9.76156 1.08482 8.62406 2.07357 7.87531L10.2423 1.31906C12.0411 -0.105937 14.5473 -0.105937 16.3423 1.31656L24.5698 7.87906C25.5361 8.61531 26.1086 9.75031 26.1248 10.9778V21.8966C26.1248 24.7828 23.7573 27.1316 20.8461 27.1316Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.9367c70807984ab68a4e6950c58c6186.svg";
export { ForwardRef as ReactComponent };